<div class="page-container container roles-rights-container">
  <app-utility-toolbar></app-utility-toolbar>
  <h1 class="header">Roles and Rights Management</h1>
  <div class="row toolbar w-100"></div>
  @if (gridView) {
    <kendo-grid
      #rightsGrid="kendoGrid"
      [data]="gridView"
      class="col-12"
      [height]="750"
      [pageSize]="pageSize"
      [pageable]="true"
      [skip]="skip"
      (pageChange)="pageChange($event)"
      [filterable]="true"
      [filter]="state.filter"
      [sortable]="sortSettings"
      [sort]="sort"
      (dataStateChange)="dataStateChange($event)"
      [navigable]="true"
    >
      <ng-template kendoGridToolbarTemplate>
        <span>
          <button
            mat-raised-button
            color="primary"
            class="ms-2"
            (click)="openRoleDialog('', true)"
          >
            <mat-icon>add</mat-icon>Add Role
          </button>
          <button
            mat-raised-button
            color="primary"
            class="ms-2"
            (click)="openRightDialog()"
          >
            <mat-icon>add</mat-icon>Add Right
          </button>
        </span>

        <span>
          <button
            mat-raised-button
            color="primary"
            class="ms-2"
            (click)="exportToExcel(rightsGrid)"
          >
            <mat-icon>cloud_download</mat-icon>Download Excel File
          </button>
          <button
            mat-raised-button
            color="primary"
            class="ms-2"
            (click)="downloadHistoryReport()"
          >
            <mat-icon>download</mat-icon>Download History Report
          </button>
        </span>
      </ng-template>

      <kendo-grid-column [width]="45">
        <ng-template kendoGridCellTemplate let-dataItem>
          <button
            mat-icon-button
            color="primary"
            (click)="openRoleDialog(dataItem.name)"
            matTooltip="Edit Right"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="name"
        title="Name"
        [width]="150"
      ></kendo-grid-column>
      <kendo-grid-column
        field="id"
        title="Role ID"
        [width]="150"
      ></kendo-grid-column>
      <kendo-grid-column
        field="rightsString"
        title="Assigned Rights"
        [width]="400"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <span class="assigned-rights">
            @for (right of dataItem.rights; track right) {
              @if (right !== '') {
                <span> {{ right }}, {{ ' ' }} </span>
              }
            }
          </span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-excel
        fileName="RightBridge-roles-rights.xlsx"
      ></kendo-grid-excel>
    </kendo-grid>
  }
</div>
<ngx-loading [show]="loading"></ngx-loading>
